import { useDispatch, useSelector } from "react-redux";

import { Checkbox } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";
import {
    selectIsAggregatedDataUsed,
    setUseAggregatedCountryData,
} from "app/pages/sales-intelligence/modules/leads-search";
import trackingService from "app/pages/sales-intelligence/sub-modules/advanced-search/services/tracking/advancedSearchTrackingService";

import { StyledCheckboxWrapper } from "./styles";

const AggregatedDataCheckbox = () => {
    const dispatch = useDispatch();
    const isAggregatedDataUsed = useSelector(selectIsAggregatedDataUsed);

    const handleUseAggregatedDataChange = () => {
        trackingService.trackToggleAggregatedData(!isAggregatedDataUsed);

        dispatch(setUseAggregatedCountryData(!isAggregatedDataUsed));
    };

    return (
        <StyledCheckboxWrapper>
            <Checkbox
                label={translate("si.lead_gen_filters.aggregated_data")}
                onClick={handleUseAggregatedDataChange}
                selected={isAggregatedDataUsed}
            />
        </StyledCheckboxWrapper>
    );
};

export default AggregatedDataCheckbox;
